import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({submitting, onClose, submitForm}) => (
  <div className="roomMoveModalButtons">
    <Button transparent white className="cancel" onClick={onClose}>
      Cancel
    </Button>
    <Button
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting}
      className="submit"
      onClick={submitForm}>
      Create a room move
    </Button>
  </div>
);

export default Buttons;
